import React, { useState, useEffect } from "react";
import classes from "./ManageApproval.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import Footer from "../../Components/Footer/Footer";
import { Trash2, Plus, Edit } from "lucide-react";
import "react-loading-skeleton/dist/skeleton.css";
import api, { withCompanyId } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import Swal from 'sweetalert2';
import { Spinner, Button, Modal, Form, Row, Col } from 'react-bootstrap';
import Select from "react-select";

const ManageApproval = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [allSelected, setAllSelected] = useState(false);
    const [userPer, setUserPer] = useState("");
    const [selectedRoles, setSelectedRoles] = useState({});
    
    // Modals
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPermisionOpenModal, setIsPermissionModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    
    const [NewUser, setNewUser] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [roles, setRoles] = useState([]);
    const [roleLoading, setRoleLoading] = useState(false);

    // --- EDIT MODE STATE ---
    const [isEditMode, setIsEditMode] = useState(false);

    // --- NEW WORKFLOW REPEATER STATES ---
    const [selectedLoanProduct, setSelectedLoanProduct] = useState(null);
    const [stages, setStages] = useState([{ id: Date.now(), selectedRole: null }]);
    // Demo list of loan products
    const [loanProducts, setLoanProducts] = useState([]);

    // --- Search state ---
    const [searchTerm, setSearchTerm] = useState("");

    const pageMap = {
        "/dashboard": "Dashboard",
        "/transactions": "Transactions",
        "/accounts": "Accounting",
        "/reports": "Reports",
        "/banking": "Banking",
        "/settings": "Settings",
    };

    // Custom styles for React Select to keep UI consistent and clean
    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            borderRadius: '8px',
            borderColor: state.isFocused ? '#2e7d32' : '#e0e0e0',
            boxShadow: state.isFocused ? '0 0 0 1px #2e7d32' : 'none',
            minHeight: '42px',
            '&:hover': {
                borderColor: '#2e7d32',
            }
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#a0a0a0',
            fontSize: '14px',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#2e7d32' : state.isFocused ? '#f1f8e9' : 'white',
            color: state.isSelected ? 'white' : '#333333',
            fontSize: '14px',
            '&:active': {
                backgroundColor: '#2e7d32',
            }
        })
    };

    const fetchNewUser = async () => {
        try {
            const res = await api.get(`/v1/get-all-loan-approval-level`);
            const newUserData = res.data?.data || [];
            setNewUser(newUserData);
        } catch (err) {
            console.error("Error fetching user:", err?.response?.data || err.message);
            setError(err.response?.data?.message || "Failed to fetch users. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const fetRoles = async () => {
        setRoleLoading(true);
        try {
            const response = await api.get(`/v1/payroll/role`);
            const data = response.data?.data || [];
            setRoles(data);
            
            const initialMap = {};
            data.forEach(permission => {
                initialMap[permission.id] = false;
            });
            setSelectedRoles(initialMap);
        } catch (error) {
            console.error(error.response?.data?.message);
            setRoles([]);
        } finally {
            setRoleLoading(false);
        }
    };

    useEffect(() => {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) {
            setError("Authorization token not found.");
            navigate('/signin');
            return;
        }
        fetchNewUser();
        fetRoles();
    }, [navigate]);

    // Format roles fetched from API to be compatible with react-select
    const roleOptions = roles.map(role => ({
        value: role.id,
        label: role.name
    }));

    // --- REPEATER ACTIONS ---
    const handleAddStage = () => {
        setStages([...stages, { id: Date.now(), selectedRole: null }]);
    };

    const handleRemoveStage = (id) => {
        if (stages.length > 1) {
            setStages(stages.filter(stage => stage.id !== id));
        }
    };

    const handleRoleChange = (stageId, selectedOption) => {
        setStages(stages.map(stage => 
            stage.id === stageId ? { ...stage, selectedRole: selectedOption } : stage
        ));
    };

    // --- EDIT TRIGGER ---
// --- EDIT TRIGGER ---
    const handleEditClick = (user) => {
        setIsEditMode(true);
        
        // Populate the locked/disabled loan product select field
        setSelectedLoanProduct({
            label: user.loan_name,
            value: user.loan_id || user.id 
        });

        // Map existing levels array to stage representations
        if (Array.isArray(user.loan_approval_levels) && user.loan_approval_levels.length > 0) {
            const mappedStages = user.loan_approval_levels.map((level, index) => {
                // Find the exact matching role from your fetched list to get its true name
                const matchingRole = roles.find(r => Number(r.id) === Number(level.role_id));
                
                return {
                    id: level.id || `${Date.now()}-${index}`,
                    selectedRole: {
                        value: level.role_id,
                        // Stamping the exact match name, falling back to what the level object says if roles array isn't populated
                        label: matchingRole ? matchingRole.name : (level.role_name || `Role Profile ${level.role_id}`)
                    }
                };
            });
            setStages(mappedStages);
        } else {
            setStages([{ id: Date.now(), selectedRole: null }]);
        }

        setIsModalOpen(true);
    };
    // --- WORKFLOW SUBMISSION (CREATE & UPDATE) ---
    const handleWorkflowSubmit = async (e) => {
        e.preventDefault();

        if (!selectedLoanProduct) {
            Swal.fire("Error", "Please select a loan product", "error");
            return;
        }

        const hasEmptyRole = stages.some(stage => !stage.selectedRole);
        if (hasEmptyRole) {
            Swal.fire("Error", "Please assign a role to all stages", "error");
            return;
        }

        setSubmitting(true);

        const payload = {
            loan_id: selectedLoanProduct.value,
            role_id: stages.map(stage => stage.selectedRole.value)
        };

        const body = withCompanyId(payload);

        // Conditional Endpoint depending on mode
        const endpoint = isEditMode ? `/v1/update-loan-approval-level` : `/v1/specify-loan-approval-level`;

        try {
            const response = await api.post(endpoint, body);

            Swal.fire({
                icon: "success",
                title: "Success",
                text: response.data.message || `Workflow ${isEditMode ? 'updated' : 'created'} successfully!`,
                timer: 2000,
                showConfirmButton: false,
            });

            // Reset state upon successful save
            handleCloseModal();
            fetchNewUser();
        } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                const { message } = error.response.data;
                if (typeof message === 'string') errorMessage = message;
                else if (Array.isArray(message)) errorMessage = message.join('; ');
                else if (typeof message === 'object') {
                    const firstKey = Object.keys(message)[0];
                    const messages = message[firstKey];
                    errorMessage = Array.isArray(messages) ? messages.join('; ') : messages;
                }
            }
            Swal.fire({
                icon: "error",
                title: `Failed to ${isEditMode ? 'Update' : 'Create'} Workflow`,
                text: errorMessage,
            });
        } finally {
            setSubmitting(false);
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setIsEditMode(false);
        setSelectedLoanProduct(null);
        setStages([{ id: Date.now(), selectedRole: null }]);
    };

    // --- FILTER ROLES BY SEARCH ---
    const filteredRoles = NewUser.filter((role) =>
        role.loan_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        const fetchLoanProducts = async () => {
            try {
                const res = await api.get('/v1/loan_account');
                if (res.data && Array.isArray(res.data.data)) {
                    const formattedProducts = res.data.data.map((loan) => ({
                        label: loan.loan_name,      
                        value: loan.id,             
                        ...loan                     
                    }));
                    
                    setLoanProducts(formattedProducts);
                } else {
                    setLoanProducts([]);
                }
            } catch (err) {
                setLoanProducts([]);
            }
        };
        fetchLoanProducts();
    }, []);

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />
            <div className={classes.PgeContainerDisp}>
                <header className={classes.FrtHeaderOne}>
                    <h2 className={classes.FrtTitleOne}>Manage Approval Levels</h2>
                    <h1 className={classes.Titles}>
                        Create and customize administrative roles, assign system permissions, and control access levels.
                    </h1>
                </header>

                <div className={classes.headerforActions}>
                    <div className={classes.actionsSideRight}>
                        <div className={classes.inputWrapperTxt}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreenLrg} />
                            <input 
                                type="text" 
                                className={classes.searchLxtBar} 
                                placeholder="Search approvals" 
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <button
                        className={classes.btnssBtnss}
                        onClick={() => {
                            setIsEditMode(false);
                            setIsModalOpen(true);
                        }}
                    >
                       + Create Workflow
                    </button>
                </div>

                <div className={classes.newUserCont}>
                    <div className={classes.tableResponsiveWrapper}>
                        <table className={classes.newUserTable}>
                            <thead>
                                <tr>
                                    <th style={{ width: 40 }}>S/N</th>
                                    <th>Loan Product</th>
                                    <th>Created At</th>
                                    <th>Updated At</th>
                                    <th style={{ width: 100, textAlign: "center" }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    Array(5).fill().map((_, idx) => (
                                        <tr key={idx}>
                                            {Array(5).fill().map((_, i) => (
                                                <td key={i}><Skeleton height={20} style={{ marginBottom: 10 }} /></td>
                                            ))}
                                        </tr>
                                    ))
                                ) : filteredRoles.length === 0 ? (
                                    <tr>
                                        <td colSpan={5} style={{ textAlign: "center" }}>No workflow found.</td>
                                    </tr>
                                ) : (
                                    filteredRoles.map((user, index) => (
                                        <tr key={user.id}>
                                            <td style={{ width: 40 }}>{index + 1}</td>
                                            <td>{user.loan_name}</td>
                                            <td style={{ width: 200 }}>{new Date(user.created_at).toLocaleDateString()}</td>
                                            <td style={{ width: 200 }}>{new Date(user.updated_at).toLocaleDateString()}</td>
                                            <td style={{ width: 100, textAlign: "center" }}>
                                                <Button
                                                    variant="light"
                                                    style={{ color: "#2e7d32", backgroundColor: "transparent", border: "none" }}
                                                    onClick={() => handleEditClick(user)}
                                                    title="Edit Workflow"
                                                >
                                                    <Edit size={18} />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* --- CREATE/EDIT WORKFLOW MODAL --- */}
            <Modal 
                show={isModalOpen} 
                onHide={handleCloseModal} 
                size="lg" 
                centered
                dialogClassName="custom-workflow-modal"
            >
                <Modal.Header closeButton style={{ borderBottom: '1px solid #f0f0f0', padding: '20px 24px' }}>
                    <div>
                        <Modal.Title style={{ fontWeight: '700', fontSize: '1.25rem', color: '#1a1a1a' }}>
                            {isEditMode ? "Modify Approval Workflow" : "Create Approval Workflow"}
                        </Modal.Title>
                        <small className="text-muted">
                            {isEditMode ? "Adjust approval hierarchies for this product." : "Set up multi-level structures for loan approvals."}
                        </small>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ padding: '24px' }}>
                    <Form onSubmit={handleWorkflowSubmit}>
                        {/* Loan Select wrapper */}
                        <Row className="mb-4">
                            <Col md={12}>
                                <Form.Group style={{ maxWidth: '400px' }}>
                                    <Form.Label style={{ fontWeight: '600', fontSize: '14px', color: '#333', marginBottom: '8px' }}>
                                        Select Loan Product
                                    </Form.Label>
                                    <Select
                                        options={loanProducts}
                                        value={selectedLoanProduct}
                                        onChange={setSelectedLoanProduct}
                                        placeholder="Choose loan product..."
                                        styles={customSelectStyles}
                                        isSearchable
                                        isDisabled={isEditMode} // Stamped disabled during editing
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                       {selectedLoanProduct && (
                        <div className="mt-4">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 style={{ fontWeight: '700', fontSize: '15px', color: '#333', margin: 0 }}>
                                    Approval Stages Setup
                                </h5>
                            </div>
                            <div className="table-responsive" style={{ border: '1px solid #eaeaea', borderRadius: '8px', overflow: 'hidden' }}>
                                <table className="table table-hover align-middle mb-0" style={{ fontSize: '14px' }}>
                                    <thead style={{ backgroundColor: '#f9fbf9', borderBottom: '1px solid #eaeaea' }}>
                                        <tr>
                                            <th style={{ width: '120px', padding: '12px 16px', color: '#555', fontWeight: '600' }}>Stages</th>
                                            <th style={{ padding: '12px 16px', color: '#555', fontWeight: '600' }}>Role</th>
                                            <th style={{ width: '100px', padding: '12px 16px', textAlign: 'center', color: '#555', fontWeight: '600' }}>
                                                <Button 
                                                    variant="success" 
                                                    size="sm" 
                                                    onClick={handleAddStage}
                                                    title="Add New Stage"
                                                    style={{ 
                                                        backgroundColor: '#2e7d32', 
                                                        borderColor: '#2e7d32', 
                                                        borderRadius: '6px',
                                                        padding: '4px 8px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '4px'
                                                    }}
                                                >
                                                    <Plus size={14} /> Add
                                                </Button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stages.map((stage, index) => (
                                            <tr key={stage.id} style={{ borderBottom: '1px solid #eaeaea' }}>
                                                <td style={{ padding: '16px', fontWeight: '600', color: '#2e7d32' }}>
                                                    Stage {index + 1}
                                                </td>
                                                <td style={{ padding: '12px 16px' }}>
                                                    <Select
                                                        options={roleOptions}
                                                        value={stage.selectedRole}
                                                        onChange={(selectedOption) => handleRoleChange(stage.id, selectedOption)}
                                                        placeholder="Select role profile..."
                                                        isLoading={roleLoading}
                                                        isSearchable
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                minHeight: "40px",
                                                                height: "40px",
                                                                width: '100%',
                                                                borderRadius: "6px",
                                                                borderColor: "#22c55e",
                                                                fontSize: 13,
                                                                boxShadow: "none",
                                                                "&:hover": {
                                                                    borderColor: "#16a34a",
                                                                },
                                                            }),
                                                            valueContainer: (provided) => ({
                                                                ...provided,
                                                                height: "40px",
                                                                padding: "0 8px",
                                                            }),
                                                            input: (provided) => ({
                                                                ...provided,
                                                                margin: 0,
                                                                padding: 0,
                                                                fontSize: 13,
                                                                width: '100%'
                                                            }),
                                                            indicatorsContainer: (provided) => ({
                                                                ...provided,
                                                                height: "40px",
                                                            }),
                                                            clearIndicator: (provided) => ({
                                                                ...provided,
                                                                padding: "4px",
                                                            }),
                                                            dropdownIndicator: (provided) => ({
                                                                ...provided,
                                                                padding: "4px",
                                                            }),
                                                            menuPortal: (provided) => ({
                                                                ...provided,
                                                                zIndex: 99999, 
                                                            }),
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 99999,
                                                                fontSize: 13
                                                            }),
                                                        }}
                                                    />
                                                </td>
                                                <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                                                    <Button 
                                                        variant="light" 
                                                        onClick={() => handleRemoveStage(stage.id)}
                                                        disabled={stages.length === 1}
                                                        title="Delete Stage"
                                                        style={{ 
                                                            color: stages.length === 1 ? '#ccc' : '#d32f2f',
                                                            backgroundColor: 'transparent',
                                                            border: 'none',
                                                            padding: '6px'
                                                        }}
                                                    >
                                                        <Trash2 size={18} />
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                        <div className="d-flex justify-content-end gap-2 mt-4 pt-3" style={{ borderTop: '1px solid #f0f0f0' }}>
                            <Button 
                                variant="outline-secondary" 
                                onClick={handleCloseModal} 
                                disabled={submitting}
                                style={{ borderRadius: '8px', padding: '10px 20px', fontWeight: '500', fontSize: '14px' }}
                            >
                                Cancel
                            </Button>
                            <Button 
                                variant="primary" 
                                type="submit" 
                                disabled={submitting || !selectedLoanProduct}
                                style={{ 
                                    backgroundColor: '#2e7d32', 
                                    borderColor: '#2e7d32', 
                                    borderRadius: '8px', 
                                    padding: '10px 24px', 
                                    fontWeight: '600',
                                    fontSize: '14px'
                                }}
                            >
                                {submitting ? <Spinner animation="border" size="sm" /> : isEditMode ? "Update Workflow" : "Save Workflow"}
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            <Footer />
        </div>
    );
};

export default ManageApproval;